interface IconProps {
  icon: React.ReactNode;
  active?: boolean;
}

export const Icon = ({ icon, active }: IconProps) => (
  <div
    className={`lg:size-8 size-6 ${active ? "text-textBrand" : "text-cTextSecondary"}`}
  >
    {icon}
  </div>
);
